import { render, staticRenderFns } from "./PinboardStatusButton.vue?vue&type=template&id=0f658f2e&"
import script from "./PinboardStatusButton.vue?vue&type=script&lang=js&"
export * from "./PinboardStatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports